module.exports = __webpack_public_path__ + "static/media/deco.e23b0450.svg";